import { BackendError, Service } from '@genial/services';
import { ResponsesPensionItemResponse } from '@genial/services/dist/models';
import { selectorFamily } from 'recoil';

import { advisorIdToApisSelector, partnerIdToApisSelector } from '../../../master/selector';
import { screenName } from '../../constants';
import { statementsFilterParamsState } from '../atom';
import { PensionStatementsParamsProps } from '../types';

export const pensionStatementsQuery = selectorFamily<
  | {
      data: ResponsesPensionItemResponse[];
    }
  | null
  | undefined,
  { accountNumber: number; callEndpoint?: boolean }
>({
  key: 'CustomerDetail/pensionStatementsQuery',
  get: ({ accountNumber, callEndpoint }) => {
    return async ({ get }) => {
      const responseEmpty = { data: [] as ResponsesPensionItemResponse[] };

      if (!callEndpoint) {
        return responseEmpty;
      }

      try {
        const params = get(statementsFilterParamsState) as PensionStatementsParamsProps;
        const advisorSelected = get(advisorIdToApisSelector);
        const partnerSelected = get(partnerIdToApisSelector);

        const { data } = await Service.Finance.V1.getStatementByPensionAccountNumber({
          ...params,
          screenName,
          advisorId: advisorSelected,
          partnerId: partnerSelected,
          accountNumber,
        });

        const normalizedData = data?.map((item) => item.pension) || [];
        const response = { data: normalizedData };
        return response;
      } catch (error) {
        const backendError = error as BackendError;

        if (backendError.statusCode === 404) {
          return responseEmpty;
        }

        throw error;
      }
    };
  },
});
